import {useMemo} from 'react'
import {UserEditingFieldsGroup, useUserDetailsStore} from '@/features/users/store/userDetailsStore'

export const useUserEditModeView = (fieldsGroup: UserEditingFieldsGroup) => {
    const currentEditingFieldsGroup = useUserDetailsStore(state => state.editingFieldsGroup)
    const isEditModeEnabled = useMemo(() => currentEditingFieldsGroup == fieldsGroup, [currentEditingFieldsGroup])
    const isDisabledView = useMemo(
        () => !!currentEditingFieldsGroup && !isEditModeEnabled,
        [currentEditingFieldsGroup, isEditModeEnabled]
    )

    return {
        isEditModeEnabled,
        isDisabledView
    }
}
